// extracted by mini-css-extract-plugin
export default {"root":"Welcome__root--wGA7M","video":"Welcome__video--UBF3n"};